export default __webpack_public_path__ + "static/media/github.c2abef64.svg";